import { render } from "./CardComponent.vue?vue&type=template&id=28662b3c&scoped=true"
const script = {}

import "./CardComponent.vue?vue&type=style&index=0&id=28662b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28662b3c"]])

export default __exports__